// extracted by mini-css-extract-plugin
export default {"header":"IC","container":"JC","accordeonitem":"KC","itemsticky":"LC","itemopen":"MC","open":"NC","productname":"OC","productinfo":"PC","flavorstext":"QC","invalidlimit":"RC","limit":"SC","scrollUpAccordion":"TC","wrapper":"UC"};
    if(module.hot) {
      // 1715188236519
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  